import React, { Fragment } from 'react'
import Tooltip from '@mui/material/Tooltip'
import CopyToClipboard from '../../../../../../../CopyToClipboard'
import unknownGirl from '../../img/unknown-girl.png'
import unknownMan from '../../img/unknown-man.png'
import useStyles from '../../styles'

function UserCell({ value, data }: { value : any, data: any }) {
  const content = <Content value={value} />
  const classes = useStyles()

  if (value?.user_url === null) {
    return <span className={`dx_global_user ${classes.user}`}>{content}</span>
  }

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <a
        href={value?.user_url}
        style={{ pointerEvents: data.actions?.disable ? "none" : 'auto' }}
        className={`dx_global_user ${classes.user}`}
      >{content}</a>
      <CopyToClipboard content link={value?.name} />
    </div>
  )
}

function Content({ value }: { value: any }) {
  const classes = useStyles()

  return <>
    <img
      alt=""
      src={value?.avatar?.['40x40']?.src || (value.gender === "f" ? unknownGirl : unknownMan)}
      width={40}
      height={40}
      className={classes.avatar}
    />
    {
      value.mood !== undefined &&
      <Tooltip title={`${value?.mood?.reaction}, ${value?.mood?.date}`} enterTouchDelay={0}>
        <span className={classes.mood}>{value?.mood?.emoji}</span>
      </Tooltip>
    }
    <span className={classes.info}>
      <h5 className={classes.name}>{value?.name}</h5>
      <span className={classes.position}>{value?.position}</span>
    </span>
  </>
}

export { UserCell }
